import { permissionNames } from '../auth/authorization'

export const menuSections = [
  {
    key: 'events',
    name: 'Događaji',
    requiredPermissions: [permissionNames.eventsAccess],
    submenus: [
      { name: 'Popis događaja', icon: 'mdi-calendar-check-outline', path: '/events', requiredPermissions: [permissionNames.eventsAccess] },
      { name: 'Popis uzvanika', icon: 'mdi-account-outline', path: '/events/invitees', requiredPermissions: [permissionNames.eventsCandidatesAccess] },
      { name: 'Popis dokumenata', icon: 'mdi-clipboard-text-outline', path: '/events/documents', requiredPermissions: [permissionNames.eventsEdit] },
      { name: 'Popis aktivnosti', icon: 'mdi-clipboard-text-outline', path: '/events/activities', requiredPermissions: [permissionNames.eventsEdit] },
    ],
  },
  {
    key: 'fleet',
    name: 'Vozni park',
    requiredPermissions: [permissionNames.driveparkAccess],
    submenus: [
      { name: 'Kalendar zauzetosti', icon: 'mdi-calendar-month-outline', path: '/fleet/calendar' },
      { name: 'Zapisnici', icon: 'mdi-file-sign', path: '/fleet/forms' },
    ],
  },
  {
    key: 'employee-evaluation',
    name: 'Evaluacija zaposlenika',
    showToggle: true,
    submenus: [],
  },
  {
    key: 'inventory',
    name: 'Inventar',
    headerName: 'Inventories',
    requiredPermissions: [permissionNames.driveparkAccess],
    submenus: [
      { name: 'Popis vozila', icon: 'mdi-car-side', path: '/inventory/vehicles' },
    ],
  },
]
